import { Fragment } from 'react'
import { Icon } from '@trustycars/genie-ui/icons'
import { Button, Spinner } from '@trustycars/genie-ui/components'
import { trueOrUndefined } from '@trustycars/genie-ui/functions'

import { useAuthenticatedLayout } from '../context'

import {
  container,
  description as descriptionStyle,
  header,
  title as titleStyle,
  actions,
  message
} from './styles.css'
import VerifyPhoneBlock from '$blocks/VerifyPhoneBlock'

const SidebarActionCard = () => {
  const {
    sidebarActions: { formattedActions, hasMultipleActions, rotateAction }
  } = useAuthenticatedLayout()

  return (
    <>
      {formattedActions.map(
        ({
          id,
          description,
          isActive,
          disabled,
          loading,
          onClick,
          title,
          props,
          actionText,
          resMessage
        }) => (
          <Fragment key={id}>
            <article className={container} hidden={trueOrUndefined(!isActive)}>
              <div className={header}>
                <h2 className={titleStyle}>{title}</h2>

                <p className={descriptionStyle}>{description}</p>
              </div>

              <div className={actions}>
                <Button onClick={onClick} disabled={disabled || loading}>
                  {loading && <Spinner />}
                  {actionText}
                </Button>

                {hasMultipleActions && (
                  <Button
                    onClick={rotateAction}
                    disabled={loading}
                    title="Next action"
                    styleVariants={{
                      kind: 'warning',
                      category: 'icon',
                      size: 'small',
                      type: 'text'
                    }}
                  >
                    <Icon namespace="Recycling" />
                  </Button>
                )}
              </div>

              {resMessage && <p className={message}>{resMessage}</p>}
            </article>

            {id === 'phone' && (
              <VerifyPhoneBlock {...props} loading={loading} />
            )}
          </Fragment>
        )
      )}
    </>
  )
}

export default SidebarActionCard
